import React from 'react';
import './Nav.css';
import Logo from '../../Images/Logo.png';
import Logout from '../../Images/logout-animated.gif'
import { Link } from 'react-router-dom';

import { toast } from 'react-toastify';


function Nav(props) {

    const logout = () => {
        localStorage.clear()
        toast.info('Logged Out Successfully')
    }
    return (

        <section className="section-content">
            <div className="row">
                <main>
                    {/* <!-- ============= COMPONENT ============== --> */}
                    <nav id="sidenav" className="sidebar siderbar-navigation card">
                        <div className="text-center bg-white py-3">
                            <img className="img-fluid logo1 " src={Logo} alt="err" />
                        </div>
                        <ul className="nav  sidebar-list-item" id="nav_accordion">

                            <li className='nav-item my-2 w-100'  >
                                <div className="accordion" id="dropdown-first">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="masters">
                                            <a href="#" className="accordion-button  text-decoration-none  acc-btn w-100" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFirst" aria-expanded="true" aria-controls="collapseFirst">
                                                <Link className={`d-flex nav-link font-size ${props.TaskTitleClass}`} >Menu <i className="fa-solid fa-chevron-down ms-auto"></i></Link>
                                            </a>
                                        </h2>
                                        <div id="collapseFirst" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#dropdown-first">
                                            <div className="accordion-body ac-body">
                                                <ul className='list-unstyled drop-list-item' >
                                                    <li><Link to="/menu/audiolist" className={`nav-link anchor-font ${props.audio}`}> All Audios</Link></li>
                                                    <li><Link to="/menu/videolist" className={`nav-link anchor-font ${props.video}`}>  All Videos</Link></li>
                                                    <li><Link to={"/menu/aartilist"} className={`nav-link anchor-font ${props.aarti}`}>  All Aarti</Link></li>
                                                    <li><Link to={"/menu/chalisalist"} className={`nav-link anchor-font ${props.chalisa}`}>  All Chalisa</Link></li>
                                                    <li><Link to={"/menu/bhajanlist"} className={`nav-link anchor-font ${props.bhajan}`}>All Bhajan</Link></li>
                                                    <li><Link to={"/menu/bhajancategorylist"} className={`nav-link anchor-font ${props.category}`}>All Bhajan Category</Link></li>
                                                    <li><Link to={"/menu/stutilist"} className={`nav-link anchor-font ${props.stuti}`}>All Stuti</Link></li>
                                                    <li><Link to={"/menu/strotralist"} className={`nav-link anchor-font ${props.strotra}`}>All Strotra</Link></li>
                                                    <li><Link to={"/menu/bhaktilist"} className={`nav-link anchor-font ${props.bhakti} `}> All Bhakti</Link></li>
                                                    <li><Link to={"/menu/pujalist"} className={`nav-link anchor-font ${props.puja}`}> All Puja</Link></li>
                                                    <li><Link to={"/menu/storylist"} className={`nav-link anchor-font ${props.story}`}> All Story</Link></li>
                                                    <li><Link to={"/menu/shortvideolist"} className={`nav-link anchor-font ${props.shortvideo}`}> All Short Video</Link></li>
                                                    <li><Link to={"/menu/kittigameslist"} className={`nav-link anchor-font ${props.kittigames}`}> All Kitti Games</Link></li>
                                                    <li><Link to={"/menu/maharajlist"} className={`nav-link anchor-font ${props.maharaj}`}> All Maharaja</Link></li>
                                                    <li><Link to={"/menu/suvicharlist"} className={`nav-link anchor-font ${props.suvichar}`}> All Suvichar</Link></li>
                                                </ul>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            {/* dropdown */}
                            <li className='nav-item  w-100 mb-3'  >
                                <div className="accordion" id="accordionExample">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="masters">
                                            <a href='/' className="accordion-button  text-decoration-none  acc-btn w-100" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                <Link className={`d-flex nav-link  font-size  ${props.MasterTitleClass}`} >Sadhana<i className="fa-solid fa-chevron-down ms-auto"></i></Link>
                                            </a>
                                        </h2>
                                        <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                            <div className="accordion-body ac-body">
                                                <ul className='list-unstyled drop-list-item' >
                                                    <li><Link to="/vartmanlist" className={`nav-link anchor-font ${props.vartman}`}> Vartman Chaubisi</Link></li>
                                                    <li><Link to="/bhootkallist" className={`nav-link anchor-font ${props.bhootkal}`}>Bhootkal Chaubisi</Link></li>
                                                    <li><Link to="/bhavishyalist" className={`nav-link anchor-font ${props.bhavishya} `}>Bhavishya Chaubisi</Link></li>
                                                    <li><Link to="/vidhyamanlist" className={`nav-link anchor-font ${props.vidhyaman}`}> Vidhyaman Chaubisi</Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li>
                                <Link to={'/changepassword'} className={`nav-link active  `}>
                                    <i className="fa-solid fa-key ms-2 me-3"></i>
                                    Change Password </Link>
                            </li>
                            <li className="nav-item ">
                                <Link to="/" onClick={logout} className="nav-link log-out-link nav-btn text-black" href="#"><img className="icon2 " src={Logout} alt="logout" />
                                    Logout</Link>
                            </li>
                        </ul>
                    </nav>
                </main>
            </div>
        </section>

    )

}

export default Nav